import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const NoticeContainer = styled.section`
  padding: 0 12px;
`

export const NoticeList = styled.ul`
  margin: 0;
  padding-left: 20px;
  list-style: disc;
  color: ${COLORS.textPlaceholder};
`

export const NoticeItem = styled.li`
  font-size: 13px;
  line-height: 18px;
`
